import { Input } from "antd";
import styled from "styled-components";
import { COLORS } from "../../layout/theme";

export const InputAntd = styled(Input)`
	border: 1px solid ${COLORS.Secondary};
`;
